import {createAction} from 'redux-act';

export const OPEN_CONTACT_FORM_MODAL = createAction(
  'emailMarketing/OPEN_CONTACT_FORM_MODAL'
);

export const OPEN_INFORMATION_MODAL = createAction(
  'emailMarketing/OPEN_INFORMATION_MODAL'
);

export const POST_CONTACT_FORM = createAction(
  'emailMarketing/POST_CONTACT_FORM'
);
export const GET_MARKETING_STATISTIC = createAction(
  'emailMarketing/GET_MARKETING_STATISTIC'
);
export const GET_MARKETING_STATISTIC_SUCCESS = createAction(
  'emailMarketing/GET_MARKETING_STATISTIC_SUCCESS'
);
export const SET_EMAIL_MARKETING_RESULT_PAGE_SPINNER = createAction(
  'emailMarketing/SET_EMAIL_MARKETING_RESULT_PAGE_SPINNER'
);
export const GET_EMAIL_MARKETING_TRIAL_DATE = createAction(
  'emailMarketing/GET_EMAIL_MARKETING_TRIAL_DATE'
);
export const SET_EMAIL_MARKETING_TRIAL_DATE = createAction(
  'emailMarketing/SET_EMAIL_MARKETING_TRIAL_DATE'
);

export const GET_EMAIL_MARKETING_CAMPAIGNS = createAction(
  'emailMarketing/GET_EMAIL_MARKETING_CAMPAIGNS'
);
export const GET_EMAIL_MARKETING_CAMPAIGNS_SUCCESS = createAction(
  'emailMarketing/GET_EMAIL_MARKETING_CAMPAIGNS_SUCCESS'
);
export const GET_EMAIL_MARKETING_CAMPAIGNS_FAILURE = createAction(
  'emailMarketing/GET_EMAIL_MARKETING_CAMPAIGNS_FAILURE'
);
export const SET_EMAIL_MARKETING_CAMPAIGNS_SPINNER = createAction(
  'emailMarketing/SET_EMAIL_MARKETING_CAMPAIGNS_SPINNER'
);
export const SET_EMAIL_MARKETING_CAMPAIGNS_PAGE = createAction(
  'emailMarketing/SET_EMAIL_MARKETING_CAMPAIGNS_PAGE'
);
export const RESET_EMAIL_MARKETING_CAMPAIGNS = createAction(
  'emailMarketing/RESET_EMAIL_MARKETING_CAMPAIGNS'
);
export const SET_EMAIL_MARKETING_CAMPAIGNS_FILTERS = createAction(
  'emailMarketing/SET_EMAIL_MARKETING_CAMPAIGNS_FILTERS'
);

export const GET_EMAIL_MARKETING_CAMPAIGN_DETAIL = createAction(
  'emailMarketing/GET_EMAIL_MARKETING_CAMPAIGN_DETAIL'
);
export const GET_EMAIL_MARKETING_CAMPAIGN_DETAIL_SUCCESS = createAction(
  'emailMarketing/GET_EMAIL_MARKETING_CAMPAIGN_DETAIL_SUCCESS'
);
export const SET_EMAIL_MARKETING_CAMPAIGN_DETAIL_SPINNER = createAction(
  'emailMarketing/SET_EMAIL_MARKETING_CAMPAIGN_DETAIL_SPINNER'
);
export const CLEAR_EMAIL_MARKETING_CAMPAIGN_DETAIL = createAction(
  'emailMarketing/CLEAR_EMAIL_MARKETING_CAMPAIGN_DETAIL'
);

export const GET_EMAIL_MARKETING_CAMPAIGN_PREVIEW = createAction(
  'emailMarketing/GET_EMAIL_MARKETING_CAMPAIGN_PREVIEW'
);
export const GET_EMAIL_MARKETING_CAMPAIGN_PREVIEW_SUCCESS = createAction(
  'emailMarketing/GET_EMAIL_MARKETING_CAMPAIGN_PREVIEW_SUCCESS'
);
export const GET_EMAIL_MARKETING_CAMPAIGN_PREVIEW_FAILURE = createAction(
  'emailMarketing/GET_EMAIL_MARKETING_CAMPAIGN_PREVIEW_FAILURE'
);
export const SET_EMAIL_MARKETING_CAMPAIGN_PREVIEW_SPINNER = createAction(
  'emailMarketing/SET_EMAIL_MARKETING_CAMPAIGN_PREVIEW_SPINNER'
);
